import { RenderFieldExtensionCtx } from 'datocms-plugin-sdk';
import { Canvas } from 'datocms-react-ui';
import BrandfolderSearch from '../components/BrandfolderSearch';

type PropTypes = {
  ctx: RenderFieldExtensionCtx;
};

export default function FieldExtension({ ctx }: PropTypes) {
  return (
    <Canvas ctx={ctx}>
      <BrandfolderSearch ctx={ctx} />
    </Canvas>
  );
}